// The seventeen mill stands, in the order the legacy screen lays them out. The procedure
// returns one column per stand holding 1 when that stand's rolls were changed during the
// transition, and NULL when there is no roll change on record for the incoming campaign.
export const STAND_COLUMNS = [
	"H1",
	"V2",
	"H3",
	"HV4",
	"V5",
	"H6",
	"H7",
	"V8",
	"H9",
	"H10",
	"HV11",
	"H12",
	"H13",
	"HV14",
	"H15",
	"HV16",
	"H17",
] as const;

export type StandColumn = (typeof STAND_COLUMNS)[number];

// One row per transition between consecutive campaigns, not per campaign.
export interface ProductChangeRow
	extends Partial<Record<StandColumn, number | null>> {
	ProductionDate: string | null;
	Shift: string | null;
	Crew: string | null;
	FromProductSize: string | null;
	ToProductSize: string | null;
	// UTC, like every timestamp in this database.
	StartChange: string | null;
	EndChange: string | null;
	// Minutes. NetChangeTime is ChangeTime minus the delays that overlapped the change,
	// mechanical ones excepted.
	ChangeTime: number | null;
	NetChangeTime: number | null;
	Goal: number | null;
	// Goal / ChangeTime * 100, so it is 0 whenever the size pair has no goal on record.
	ChangeTimeKPI: number | null;
	StandChanged: number | null;
}

export interface ProductSizeOption {
	Id: number;
	Name: string;
}
